import { useInputActionHandler } from 'app/modules/wallforming/components/input-binding/hooks/useInputActionHandler';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { useProjectsManager } from 'app/modules/wallforming/components/projects-manager/hooks/useProjectsManager';
import { ProjectsPanel } from 'app/modules/wallforming/components/projects-manager/ProjectsPanel';
import { SaveProjectDialog } from 'app/modules/wallforming/components/projects-manager/SaveProjectDialog';
import { ProjectsDialog } from 'app/modules/wallforming/components/projects-manager/types/projectDialog';

export const ProjectsManager = () => {
    const {
        isOpen,
        setIsOpen,
        activeDialog,
        setActiveDialog,
        projects,
        isProjectsPending,
        resolvedActiveProject,
        isDirty,
        saveName,
        setSaveName,
        saveDescription,
        setSaveDescription,
        saveError,
        loadCandidate,
        deleteCandidate,
        isSavePending,
        isLoadPending,
        isDeletePending,
        handleSaveProject,
        handleLoadProject,
        handleSaveAndLoadProject,
        handleDeleteProject,
        openLoadDialog,
        openDeleteDialog,
        openSaveDialog
    } = useProjectsManager();

    useInputActionHandler(InputActionId.GeneralSave, openSaveDialog);

    return (
        <>
            {isOpen && (
                <ProjectsPanel
                    activeDialog={activeDialog}
                    deleteCandidate={deleteCandidate}
                    isDeletePending={isDeletePending}
                    isDirty={isDirty}
                    isLoadPending={isLoadPending}
                    isProjectsPending={isProjectsPending}
                    isSavePending={isSavePending}
                    loadCandidate={loadCandidate}
                    projects={projects}
                    resolvedActiveProject={resolvedActiveProject}
                    setActiveDialog={setActiveDialog}
                    onClose={() => setIsOpen(false)}
                    onDeleteProject={handleDeleteProject}
                    onLoadProject={handleLoadProject}
                    onOpenDeleteDialog={openDeleteDialog}
                    onOpenLoadDialog={openLoadDialog}
                    onSaveAndLoadProject={handleSaveAndLoadProject}
                />
            )}

            {activeDialog === ProjectsDialog.SAVE && (
                <SaveProjectDialog
                    isPending={isSavePending}
                    saveDescription={saveDescription}
                    saveError={saveError}
                    saveName={saveName}
                    onClose={() => setActiveDialog(ProjectsDialog.NONE)}
                    onDescriptionChange={setSaveDescription}
                    onNameChange={setSaveName}
                    onSave={handleSaveProject}
                />
            )}
        </>
    );
};
